import { currentAuthUser } from "../../utils/api";
import { getActiveBusinessId } from "../../utils/business";

// Fortschritt der Mitmach-Tutorials pro Pflegedienst (wie die Bereichs-Touren im
// localStorage). Änderungen werden per Event an Karte/Hilfe gemeldet.
const DONE_PREFIX = "sonne_tutorial_done_v1_";
export const TUTORIALS_CHANGED = "sonne:tutorials-changed";
export const START_TUTORIAL = "sonne:start-tutorial";

export function tutorialScopeId(): string | number | null {
  return getActiveBusinessId() ?? currentAuthUser()?.id ?? null;
}

const key = (id: string) => {
  const scope = tutorialScopeId();
  return scope != null ? `${DONE_PREFIX}${scope}_${id}` : null;
};

export function isTutorialDone(id: string): boolean {
  const k = key(id);
  if (!k) return false;
  try { return localStorage.getItem(k) === "1"; } catch { return false; }
}

export function markTutorialDone(id: string) {
  const k = key(id);
  if (!k) return;
  try { localStorage.setItem(k, "1"); } catch { /* ignore */ }
  window.dispatchEvent(new Event(TUTORIALS_CHANGED));
}

export function startTutorial(id: string) {
  window.dispatchEvent(new CustomEvent(START_TUTORIAL, { detail: id }));
}
